import { mapState } from "pinia";
import useModuleStore from "../stores";
import * as types from "../stores/constants";

export default {
    data (){
        return {
        }
    },
    computed: {
        ...mapState(useModuleStore,{
            user:'user',
            merchant_user_access:'merchant_user_access',
            dashboard:'dashboard'
        }),
        unfinished_application: function () {
            return !this.isPublicUser && !!this.dashboard.unfinished && this.dashboard.unfinished.hasOwnProperty('application') &&
            this.objectIsNotEmpty(this.dashboard.unfinished.application) ? this.dashboard.unfinished.application : {};
        },
        unfinished_quote: function (){
            return !this.isPublicUser && !!this.dashboard.unfinished && this.dashboard.unfinished.hasOwnProperty('quote') &&
            this.objectIsNotEmpty(this.dashboard.unfinished.quote) ? this.dashboard.unfinished.quote : {};
        },
        unfinished_entity: function () {
            let entity = '';

            if (this.objectIsNotEmpty(this.unfinished_quote)) {
                entity = 'quote';
            } else if (this.objectIsNotEmpty(this.unfinished_application)) {
                entity = 'application';
            }
            return entity;
        },
        unfinishedEntityLink: function () {
            let path = ''
            if (this.unfinished_entity === 'quote') {
                path = '/quote/edit/' + this.unfinished_quote.quote_external_id + '/business/';
            }
            if (this.unfinished_entity === 'application') {
                //Check that the logged in user is the merchant owner
                let action = 'edit', endpoint = 'business_details';
                if (this.unfinished_application.sales_owner_user_external_id !== this.user.user_external_id) {
                    action = this.unfinished_application.hasOwnProperty('merchant_owner_user_external_id') &&
                    this.unfinished_application.merchant_owner_user_external_id === this.user.user_external_id && (this.unfinished_application.hasOwnProperty('merchant_control') && this.unfinished_application.merchant_control === '1') ?
                        'edit' : 'view';
                }
                //merchant has not control (to edit), so go to review page first
                let merchant_in_control = this.unfinished_application.hasOwnProperty('merchant_control')
                    && (this.unfinished_application.merchant_control === '1');
                if (!merchant_in_control) {
                    action = 'view';
                    endpoint = 'review';
                }
                //Upload document might override the previous action&endpoint. Higher priority.
                //Seller specified merchant to upload document when seller did submission, that means the only action left is upload document
                let vm = this;
                let merchant_to_upload_document = (vm.unfinished_application.hasOwnProperty('merchant_to_upload_document')
                    && (vm.unfinished_application.merchant_to_upload_document === '1'));
                let is_bank_id_verify_configured = vm.isBankIdWorkflowConfigured();
                if (merchant_to_upload_document) {
                    if (merchant_in_control) {
                        action = 'edit';
                        endpoint = 'documents';
                        if (is_bank_id_verify_configured) {
                            endpoint = 'business_details/principals';
                        }
                    }
                    else {
                        action = 'view';
                        endpoint = 'upload_documents';
                        if (is_bank_id_verify_configured) {
                            endpoint = 'business_details/principals';
                        }
                    }
                }

                //GDPR might override the previous action&endpoint. Higher priority.
                //begin gdpr process. Matched cases will return path directly, otherwise remain the decision above
                let merchant_has_not_confirmed_gdpr = !(this.unfinished_application.hasOwnProperty('has_merchant_confirmed_gdpr')
                    && (this.unfinished_application.has_merchant_confirmed_gdpr === '1'));
                let is_application_validated = this.unfinished_application.hasOwnProperty('is_validated')
                    && (this.unfinished_application.is_validated === '1');
                if (merchant_has_not_confirmed_gdpr) {
                    if (action === 'edit') {
                        //always go to business info page for merchant to confirm gdpr
                        endpoint = types.URL_BUSINESS_INFO;
                        path = '/quote/' + action + '/' + this.unfinished_application.quote_external_id + '/'+ endpoint +'/';
                        return path;
                    }
                    else if (action === 'view' && is_application_validated && !merchant_to_upload_document) {
                        // go to review page for merchant to confirm gdpr if application is validated and documents have been uploaded.
                        endpoint = types.URL_SUBMISSION_REVIEW;
                        path = '/application/' + action + '/' + this.unfinished_application.application_reference + '/'+ endpoint +'/';
                        return path;
                    }
                }
                //end gdpr process
                path = '/application/' + action + '/' + this.unfinished_application.application_reference + '/'+ endpoint +'/';
            }
            //block a loophole where the quote is not assigned to the merchant but they have merchant_user_access
            if (this.unfinished_entity === ''){
                if (this.merchant_user_access.hasOwnProperty('quote')){
                    let quote = this.merchant_user_access.quote[0];
                    let action = quote.status_id === '1' ? 'edit' :'view';
                    path = '/quote/' + action + '/' +quote.quote_external_id + '/business/';
                }

                if (this.merchant_user_access.hasOwnProperty('application')){
                    let application = this.merchant_user_access.application[0], endpoint = '';
                    let application_status = this.parameters.APPLICATION_STATUS_PARAM.find(obj => {
                        return obj.application_status_external_id === application.application_status_external_id
                    })
                    let action = !!application_status && application_status.application_status_key === 'OPEN' ? 'edit' : 'view';

                    path = '/application/' + action + '/' + application.application_reference + '/business_details/';

                    if (application.hasOwnProperty('merchant_to_upload_document') && application.merchant_to_upload_document === '1'){
                        let is_bank_id_verify_configured = this.isBankIdWorkflowConfigured();
                        action = 'view';
                        endpoint = 'upload_documents';
                        if (is_bank_id_verify_configured) {
                            endpoint = 'business_details/principals';
                        }
                        if (application.hasOwnProperty('merchant_control') && application.merchant_control === '1') {
                            action = 'edit';
                            endpoint = 'documents';
                            if (is_bank_id_verify_configured) {
                                endpoint = 'business_details/principals';
                            }
                        }
                    }

                    //begin gdpr process. Matched cases will return path directly, otherwise remain the decision above
                    let merchant_has_not_confirmed_gdpr = !(application.hasOwnProperty('has_merchant_confirmed_gdpr')
                        && (application.has_merchant_confirmed_gdpr === '1'));
                    let is_application_validated = application.hasOwnProperty('is_validated')
                        && (application.is_validated === '1');
                    if (merchant_has_not_confirmed_gdpr) {
                        if (action === 'edit') {
                            //always go to business info page for merchant to confirm gdpr
                            endpoint = types.URL_BUSINESS_INFO;
                            path = '/quote/' + action + '/' + application.quote_external_id + '/'+ endpoint +'/';
                            return path;
                        }
                        else if (action === 'view' && is_application_validated) {
                            // go to business info page for merchant to confirm gdpr
                            endpoint = types.URL_SUBMISSION_REVIEW;
                            path = '/application/' + action + '/' + application.application_reference + '/'+ endpoint +'/';
                            return path;
                        }
                    }
                    //end gdpr process

                    path = '/application/' + action + '/' + application.application_reference + '/'+ endpoint +'/';
                }
            }

            return path;
        },
    },
    methods: {
        isMerchantViewAndUpdateDocument: function (unfinished_application) {
            let merchant_to_upload_document = !!unfinished_application
                && unfinished_application.hasOwnProperty('merchant_to_upload_document')
                && unfinished_application.merchant_to_upload_document === '1';
            let merchant_in_control = !!unfinished_application
                && unfinished_application.hasOwnProperty('merchant_control')
                && unfinished_application.merchant_control === '1';

            return merchant_to_upload_document && !merchant_in_control;
        },
        isBankIdWorkflowConfigured: function () {
            let parameters = vue_data && vue_data.hasOwnProperty('parameters') ? vue_data.parameters : null;
            if (parameters.hasOwnProperty('APPLICATION_PROCESS_ACTIONS_CHECK') && !!parameters.APPLICATION_PROCESS_ACTIONS_CHECK) {
                let workflow_actions = parameters.APPLICATION_PROCESS_ACTIONS_CHECK;
                return workflow_actions.BANK_ID_VERIFICATION === true;
            }
            return false;
        },
    }

};